<style>
    .inactive{
      color:yellow !important
    }
    .prevLinkInactive{
      color:red !important
    }
    .nextLinkInactive{
      color:red !important
    }
  </style>

<div class="px-4">
  <div class="fs-1 h4 fw-bold">Iconic moments in Maganti IT history</div>
  </div>

<section class="cd-horizontal-timeline" [ngClass]="{'loaded': loaded}">
    <div class="events-content mx-5" *ngIf="showContent">
        <ol>
          <li *ngFor="let item of timelineElements; let index = index"
              [@contentState]="item.selected ? 'active' : (index < selectedIndex ? 'left' : 'right')">
              <div class="text-white mat-h4 fw-bold" aria-haspopup="true" tabindex="0" role="button">{{item.caption}}</div>
              <div class="text-white mat-h4 fw-bold">-{{item.title}}</div>
            <!-- <em>{{item.date | date:dateFormat}}</em> -->
            <p class="text-white" style="font-size: larger;">{{item.content}}</p>
          </li>
        </ol>
      </div>


    <div class="timeline ">
      <div class="events-wrapper">
        <div class="events" #eventsWrapper [style.width.px]="eventsWrapperWidth">
          <ol>
            <li *ngFor="let item of timelineElements; let index = index">
              <a role="button" class="text-white" #timelineEvents href="#" [ngClass]="{'selected': item.selected, 'older-event': index < selectedIndex}"
                 (click)="onEventClick($event, item)">{{item.caption}}</a>
              <span></span>
            </li>
          </ol>
          <span class="filling-line" aria-hidden="true" #fillingLine></span>
        </div>
      </div>
  
      <ul class="cd-timeline-navigation">
        <li>
          <a href="#" (click)="onScrollClick($event, false)" class="prev" [ngClass]="{'inactive':prevLinkInactive}" aria-label="Previous">
            <i class="fa-regular fa-circle-right" style="color: aliceblue;"></i>
            <span class="sr-only">Previous</span>
          </a>
        </li>
        <li>
            <a href="#" (click)="onScrollClick($event, true)" class="next" [ngClass]="{'inactive':nextLinkInactive}" aria-label="Next">
            <i class="fa-regular fa-circle-left" style="color: aliceblue;"></i>
            <span class="sr-only">Next</span>
            </a>
        </li>
      </ul>
    </div>
  </section>
